import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  HStack,
  Text,
  Divider,
  Badge,
  RadioGroup,
  Radio,
  Stack,
  Card,
  CardBody,
  Heading,
} from '@chakra-ui/react';

const ReviewSendStep = ({
  recipientData,
  contentData,
  onSend,
  onBack,
  isSubmitting,
}) => {
  const [sendType, setSendType] = useState('now');
  const [scheduleDate, setScheduleDate] = useState('');
  const [scheduleTime, setScheduleTime] = useState('');

  const handleSend = () => {
    let scheduleAt = null;
    if (sendType === 'schedule' && scheduleDate && scheduleTime) {
      scheduleAt = `${scheduleDate}T${scheduleTime}:00.000Z`;
    }
    onSend({ scheduleAt });
  };

  const isScheduleValid = sendType === 'now' || (scheduleDate && scheduleTime);

  return (
    <VStack spacing={6} align="stretch">
      <Heading size="md" mb={2}>
        검토 및 발송
      </Heading>

      <Card>
        <CardBody>
          <VStack spacing={3} align="stretch">
            <HStack justify="space-between">
              <Text fontWeight="bold">총 대상:</Text>
              <Badge colorScheme="purple" fontSize="lg" p={2}>
                {recipientData.count}명
              </Badge>
            </HStack>
            {recipientData.filter &&
              Object.keys(recipientData.filter).length > 0 && (
                <Box>
                  <Text fontWeight="bold" mb={1}>
                    필터:
                  </Text>
                  <Text fontSize="sm" color="gray.600">
                    {JSON.stringify(recipientData.filter, null, 2)}
                  </Text>
                </Box>
              )}
            {recipientData.recipients.length > 0 && (
              <Box>
                <Text fontWeight="bold" mb={1}>
                  직접 입력:
                </Text>
                <Text fontSize="sm" color="gray.600">
                  {recipientData.recipients.length}개 이메일
                </Text>
              </Box>
            )}
          </VStack>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <VStack spacing={3} align="stretch">
            <HStack justify="space-between">
              <Text fontWeight="bold">제목:</Text>
              <Text>{contentData.subject}</Text>
            </HStack>
            <HStack justify="space-between">
              <Text fontWeight="bold">발신자:</Text>
              <Text>support@appplatform.co.kr</Text>
            </HStack>
            <Divider />
            <Box>
              <Text fontWeight="bold" mb={2}>
                본문 미리보기:
              </Text>
              <Box
                border="1px solid"
                borderColor="gray.200"
                borderRadius="md"
                p={4}
                maxH="300px"
                overflowY="auto"
                dangerouslySetInnerHTML={{ __html: contentData.html }}
              />
            </Box>
          </VStack>
        </CardBody>
      </Card>

      <Divider />

      <FormControl>
        <FormLabel fontWeight="bold">발송 방식</FormLabel>
        <RadioGroup value={sendType} onChange={setSendType}>
          <Stack direction="column" spacing={4}>
            <Radio value="now">즉시 발송</Radio>
            <Radio value="schedule">예약 발송</Radio>
          </Stack>
        </RadioGroup>
      </FormControl>

      {sendType === 'schedule' && (
        <HStack>
          <FormControl>
            <FormLabel>예약 날짜</FormLabel>
            <Input
              type="date"
              value={scheduleDate}
              onChange={e => setScheduleDate(e.target.value)}
            />
          </FormControl>
          <FormControl>
            <FormLabel>예약 시간</FormLabel>
            <Input
              type="time"
              value={scheduleTime}
              onChange={e => setScheduleTime(e.target.value)}
            />
          </FormControl>
        </HStack>
      )}

      <HStack spacing={4} justify="space-between" mt={6}>
        <Button onClick={onBack}>이전</Button>
        <Button
          colorScheme="purple"
          size="lg"
          onClick={handleSend}
          isLoading={isSubmitting}
          isDisabled={!isScheduleValid || recipientData.count === 0}
        >
          {sendType === 'now' ? '즉시 발송' : '예약 발송'}
        </Button>
      </HStack>
    </VStack>
  );
};

export default ReviewSendStep;
